<template>
  <main id="main">
    <header class="header_page shadow_box slideInDown">
        <p id="title_header_page" class="bold">{{ t('my_chats') }}</p>
        <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </header>

   <section class="w-100 p-3 pb-6 d-flex flex-column row-gap-3">
       
       <div class="search-container shadow-sm">
           <img src="@/assets/imgs/search.svg" class="search-icon" alt="">
           <input type="search" v-model="searchQuery" class="search-input" :placeholder="t('search_student')">
       </div>

       <div v-if="loading" class="text-center mt-5">
           <p>{{ t('loading') }}</p>
       </div>

       <div v-else-if="filteredChats.length === 0" class="text-center mt-5 text_color_gray">
           {{ t('no_chat') }}
       </div>

       <div v-else v-for="chat in filteredChats" :key="chat.chat_id" class="w-100 bg-white rounded-4 shadow p-3 cursor-pointer position-relative" @click="goToChatDetail(chat)">
           <div v-if="chat.has_unseen || chat.unseen_count > 0" class="unseen-badge"></div>
           
           <div class="d-flex justify-content-between align-items-center column-gap-3 p-3 border-bottom-custom">
               <span class="font_medium bold text-truncate">{{ chat.student_name }}</span>
               <div class="d-flex gap-2">
                   <span class="font_small text_color_gray">{{ chat.last_date }}</span>
                   <span class="font_small text_color_gray">{{ chat.last_time }}</span>
               </div>
           </div>
           <p class="p-3 font_normal text_color_gray text-truncate">{{ chat.last_message }}</p>
       </div>
   </section>
   <TeacherBottomNav />
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'
import TeacherBottomNav from '@/components/TeacherBottomNav.vue'

export default {
  name: 'TeacherMyChats',
  components: {
    TeacherBottomNav
  },
  data() {
    return {
        chats: [],
        loading: false,
        searchQuery: ''
    }
  },
  computed: {
    filteredChats() {
        if (!this.searchQuery) return this.chats;
        return this.chats.filter(chat => 
            chat.student_name.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
    }
  },
  mounted() {
    this.fetchChats();
  },
  methods: {
    async fetchChats() {
        this.loading = true;
        try {
            const userId = localStorage.getItem('user_id');
            const formData = createFormData({
                teacher_id: userId
            });

            const response = await apiClient.post('/teacher/preview_chats', formData);

            if (response.data.status === 'ok' && response.data.data) {
                this.chats = response.data.data.chats || [];
                
                if (response.data.data.has_unseen) {
                    localStorage.setItem('teacher_has_unseen_chat', '1');
                } else {
                    localStorage.setItem('teacher_has_unseen_chat', '0');
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.loading = false;
        }
    },
    goToChatDetail(chat) {
        this.$router.push({ 
            name: 'TeacherChatDetail', 
            query: { 
                chat_id: chat.chat_id,
                student_name: chat.student_name
            } 
        });
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
.border-bottom-custom {
    border-bottom: 2px solid #99B6FE;
}
.unseen-badge {
    position: absolute;
    top: 15px;
    left: 15px;
    width: 12px;
    height: 12px;
    background-color: #FF0000;
    border-radius: 50%;
    box-shadow: 0 0 5px rgba(255, 0, 0, 0.5);
}
.text_color_gray {
    color: #757575;
}
.search-container {
    display: flex;
    align-items: center;
    background-color: white;
    border-radius: 15px;
    padding: 0.8rem 1rem;
    width: 100%;
    border: 1px solid #eee;
    height: 4rem;
}
.search-icon {
    width: 1.5rem;
    height: 1.5rem;
    margin-left: 10px;
}
.search-input {
    border: none;
    outline: none;
    width: 100%;
    height: 100%;
    font-size: 1rem;
    background: transparent;
}
</style>